import type * as z from 'zod';

import { booleanFormSchema } from '@/_schemas/generic';

import { invoiceBatchQuerySchema } from './invoice-batches-query-schema';

export const invoiceBatchFormSchema = invoiceBatchQuerySchema
  .omit({
    payment_method_id: true,
  })
  .extend({
    is_paid: booleanFormSchema(),
    inherit_agreement_creation_date: booleanFormSchema(),
    inherit_invoice_date_for_payment_date: booleanFormSchema(),
  });

export type InvoiceBatchFormSchema = z.infer<typeof invoiceBatchFormSchema>;
